const ZURICH = [
  { category: 'insurance', name: 'Best Term Insurance' }
];

export const WINNERS = {
  'kbc': [
    { category: 'banking', name: 'Best Mortgage For Switchers' }
  ],
  'permanent-tsb': [
    { category: 'banking', name: 'Best First-Time Buyer Mortgage' }
  ],
  'royal-london': [
    { category: 'insurance', name: 'Best Mortgage Protection' }
  ],
  'zurich': ZURICH,
  'zurich-life': ZURICH
};
